<template>
  <div class="tag">
    <div class="d-flex justify-content-between">
      <div class="tag-boxes">
        <div class="d-flex" style="position: absolute; bottom:0;">
          <div v-for="(item ,index) in tagArray" :key="index" @click="doTag(index)" :class="{'tag-active':currentTag === index}" class="tag-body mx-1">{{item}}</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="m-auto type-selecter">
        <button @click="downloadExcel" class="btn btn-success">{{$t('export_file')}}</button>
          <select :disabled="previous" v-model="scenceId" @change="getRecordSummary" class="scene-select">
            <option v-for="item in sceneList" :value="item.id" :key="item.id">{{item.name}}</option>
          </select>
          <select v-if="scenceId" v-model="lessonId" class="scene-select">
            <option v-for="item in LessonList" :value="item.id" :key="item.id">{{item.localName}}</option>
          </select>
        </div>
        <img class="back-icon my-4" style="height:20px" @click="previousPage" src="../../../../assets/image/icon/close_lesson.png" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../../store/api'
export default {

  name: 'label-tag',
  props: {
    tagArray: {
      type: Array,
      default: () => {
        return null
      }
    },
    previous: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    pageIndex: {
      type: Number,
      default: () => {
        return 1
      }
    },
    order: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      currentTag: 0,
      sceneList: [
        {
          name: 'All',
          id: ''
        }
      ],
      LessonList: [],
      memberList: [],
      scenceId: '',
      lessonId: '',
      pageSize: 10,
      pageCount: 0,
      record: null
    }
  },
  computed: {
    classId () {
      return this.$route.params.class
    },
    recordMode () {
      return this.$route.params.mode
    }
  },
  watch: {
    recordMode (val) {
      this.scenceId = ''
      this.getRecordSummary()
    },
    async pageIndex (val) {
      // await this.getMember()
      await this.getRecordSummary()
    },
    async scenceId (val) {
      if (val) {
        this.getLessonList()
      }
      this.lessonId = ''
      await this.getRecordSummary()
    },
    lessonId (val) {
      this.getRecordSummary()
    },
    order (val) {
      this.getRecordSummary()
    }
  },
  async mounted () {
    if (this.$route.params.mode === 'App') {
      this.currentTag = 1
    } else {
      this.currentTag = 0
    }
    await this.getSceneList()
    await this.getRecordSummary()
  },
  methods: {
    doTag (mode) {
      this.currentTag = mode
      this.$emit('resetOrder', 'userName')
      this.$router.push({name: 'Record.summary', params: {mode: mode ? 'App' : 'Web'}})
    },
    previousPage () {
      this.$router.push({name: 'Record.classList'})
    },
    async getSceneList () {
      const { data } = await api.get(`/Globetrotting/Country`)
      this.sceneList.push(...data.data)
    },
    async getLessonList () {
      let params = {
        pageSize: 25
      }
      const { data } = await api.get(`Globetrotting/Country/${this.scenceId}/Lesson`, {params})
      this.LessonList = [{localName: 'All', id: ''}, ...data.data]
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../../vendor/Export2Excel')
        if (this.recordMode === 'Web') {
          const tHeader = [ '帳號', '姓名', '學習時間' ]
          const filterVal = [ 'userName', 'realName', 'spendTime' ]
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '學習紀錄')
        } else if (this.recordMode === 'App') {
          const tHeader = [ '帳號', '姓名', '金幣數', 'AR解鎖數', '任務完成數', 'App學習時間' ]
          const filterVal = [ 'userName', 'realName', 'goldNum', 'unlockNum', 'missionFinishedNum', 'spendTime' ]
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '學習紀錄')
        }
      })
    },
    async getRecordSummary () {
      let asc = (this.order === 'userName') ? 'true' : 'false'
      const { data } = await api.get(`Globetrotting/Record/Group/${this.classId}/Students/${this.recordMode}/Summary`, {
        params: {
          orderby: this.order,
          asc: asc,
          countryId: this.scenceId,
          packageId: this.lessonId,
          pageIndex: this.pageIndex,
          pageSize: 10
        }
      })
      data.countryId = this.scenceId
      data.lessonId = this.lessonId
      data.mode = this.recordMode
      data.pageIndex = this.pageIndex
      this.$emit('updatedRecord', data)
    },
    async downloadExcel () {
      const { data } = await api.get(`Globetrotting/Record/Group/${this.classId}/Students/${this.recordMode}/Summary`, {
        params: {
          orderby: this.order,
          asc: true,
          countryId: this.scenceId,
          packageId: this.lessonId,
          pageIndex: 1,
          pageSize: 10000
        }
      })
      this.export2Excel(data.data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .tag-active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  .back-icon {
    margin-right: 40px;
    margin-left: 40px;
    cursor: pointer;
  }
  .scene-select {
    margin: auto 5px !important;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20%;
    }
  }
  .form_input {
    height: 1.5rem;
  }
</style>


// WEBPACK FOOTER //
// Label.vue?53e237a2